/**
 * React: Event Emitter
 * Retrieved from: https://medium.com/@lolahef/react-event-emitter-9a3bb0c719
 */

export const EventEmitter = {
    events: {},
    dispatch: function (event, data) {
        console.log(`Dispatching event - ${event}:`, data);
        if (!this.events[event]) return;
        this.events[event].forEach(callback => callback(data));
    },
    subscribe: function (event, callback) {
        if (!this.events[event]) this.events[event] = [];
        this.events[event].push(callback);
    },
    unsubscribe(event) {
        delete this.events[event];
    }
};

export const EVENTS = {

   // notification message event
    JOIN_GROUP: "JOIN_GROUP",
    LEAVE_GROUP: "LEAVE_GROUP",
    SEND_MESSAGE_TO_GROUP: "SEND_MESSAGE_TO_GROUP",
    SEND_MESSAGE_TO_ALL: "SEND_MESSAGE_TO_ALL",
    SEND_MESSAGE_TO_ALL_EXCEPT: "SEND_MESSAGE_TO_ALL_EXCEPT",

    //
};
